import { useEffect } from 'react';
import EcoNavPage from 'eco-design/sections/eco-nav-page';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
// import { useProduct, useProductStore } from '../../../ProductProvider';
import { useProductStore } from '../../../../ProductProvider';
export default function Comp() {
    const { t } = useLang('theProductV2.NavPage');
    const { pageStatus } = useProductStore();

    const item1Href = pageStatus === 'statusC' ? '#rapid-mag-Screen4-V2' : '#rapid-mag-Screen1-V2';
    const itemsA = [
        {
            title: t('item1'),
            href: item1Href,
        },
        {
            title: t('item2'),
            href: '#rapid-mag-Screen6-V2',
        },
    ];

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const callback = () => {
            const screen1 = document.querySelector(item1Href);
            if (screen1) {
                const screen1Top = screen1.getBoundingClientRect().top;
                if (screen1Top <= 80) {
                    document.getElementById('rapid-mag-NavPage-V2')?.classList.add('active');
                } else {
                    document.getElementById('rapid-mag-NavPage-V2')?.classList.remove('active');
                }
            }
        };
        window.addEventListener('scroll', callback);
        return () => {
            window.removeEventListener('scroll', callback);
        };
    }, []);
    return (
        <section
            className={`${styles.comp}  GtmModuleData-section`}
            id="rapid-mag-NavPage-V2"
            data-section-id={'rapid-mag-NavPage-V2'}
            data-section-title="rapid-mag-NavPage-v2"
        >
            <EcoNavPage items={itemsA} openGTM />
        </section>
    );
}
